import { defaults, ScaleOptionsByType } from "chart.js";

import { TimePeriod } from "@/constants";
import { _DeepPartialObject } from "@/types/utilityTypes";

import { displayFormats } from "../base";

export const dynamicIntervalLabels = (
  _unit: TimePeriod | undefined
): _DeepPartialObject<ScaleOptionsByType<"timeseries">> => {
  if (!_unit) {
    return {};
  }
  const unit = _unit === "week" ? "month" : _unit; // weeks are quite useless and does not look good.

  return {
    type: "timeseries",
    axis: "x",
    grid: {
      drawTicks: false,
      display: false,
    },
    ticks: {
      display: true,
      source: "labels",
    },
    border: {
      display: false,
    },
    time: {
      ...defaults.scales.time,
      unit,
      tooltipFormat: "PP",
      displayFormats,
      // To display unevenly sized periods, remove these two lines:
      round: unit,
      minUnit: unit,
      // ... until here
    },
  };
};
